export default __webpack_public_path__ + "static/media/shopping-cart-3.403cc380.png";